<template>
    <div class="relative overflow-x-auto shadow-md sm:rounded-lg">
        <table class="min-w-full leading-normal">
            <thead class="bg-smoke border-none">
                <tr>
                    <th v-for="headItem in headItems" :key="headItem.name">
                        <span :class="headItem.class">{{headItem.name}}</span> 
                    </th>
                </tr>
            </thead>
            <tbody>
                <slot name="row"/>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    name:"Table",

    props: {
        headItems: {
            type: Array,
            default: () => [{name: 'Name', class: 'pl-16'},{name: 'Description', class: ''},{name: 'Type', class: ''},{name: 'size', class: ''},{name: 'Buttons', class: 'sr-only'} ],
        },
    },
}
</script>
<style scoped>
th{
    @apply px-5 py-5 text-left text-xs text-payne font-bold uppercase tracking-wider
}
</style>